import * as React from 'react';
import DOMPurify from 'dompurify';
import classNames from 'classnames';
import { useField, useFormikContext } from 'formik';
import { AstExpression, Component } from '../../../models/be/db/FormSpecification';
import { single, hasValue } from '../../../lib/utils';
import ErrorMessage from '../../../commonComponents/ErrorMessage';
import './Question.less';
import DotButton from '../buttons/DotButton';
import { evalString, evalBoolean } from '../../../core/ast';
import { isAstExpression } from '../../../core/astInterpreter';

const Question = (props: Component) => {
	const componentProps = props.props;
	const evaluatedFieldType = isAstExpression(componentProps.type)
		? evalString(componentProps.type as AstExpression, componentProps.values)
		: (componentProps.type as string);

	const fieldType = evaluatedFieldType === 'boolean' ? 'checkbox' : evaluatedFieldType;
	const fieldName = single(props.fieldNames);
	const [, meta, helpers] = useField({ name: fieldName, type: fieldType });
	const { setValue } = helpers;
	const isCheckboxType = fieldType === 'checkbox';
	const leftButtonText = componentProps.leftButtonText ?? 'Yes';
	const leftButtonValue = isCheckboxType ? true : componentProps.leftButtonText;
	const rightButtonText = componentProps.rightButtonText ?? 'No';
	const rightButtonValue = isCheckboxType ? false : componentProps.rightButtonText;
	const { values: formikValues } = useFormikContext();
	const label = evalString(componentProps.label, formikValues);
	const disabled = hasValue(componentProps.disabled)
		? evalBoolean(componentProps.disabled as boolean | AstExpression, formikValues)
		: false;

	return (
		<div className="question" id={fieldName}>
			{hasValue(props.heading) && <h3>{props.heading}</h3>}
			<p>
				<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(label) }} />
			</p>
			<div className="buttonCombo">
				<DotButton
					selected={meta.value === leftButtonValue}
					className={classNames('leftButton', meta.value === leftButtonValue ? 'selected' : '', 'longText')}
					text={leftButtonText}
					disabled={disabled}
					onClick={() => {
						setValue(leftButtonValue);
					}}
					value={leftButtonValue}
				/>
				<DotButton
					selected={meta.value === rightButtonValue}
					className={classNames('rightButton', meta.value === rightButtonValue ? 'selected' : '', 'longText')}
					text={rightButtonText}
					disabled={disabled}
					onClick={() => {
						setValue(rightButtonValue);
					}}
					value={rightButtonValue}
				/>
			</div>
			{meta.touched && <ErrorMessage message={meta.error} />}
		</div>
	);
};

export default Question;
